"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const renderer_1 = require("../renderer");
var Cesium = window['Cesium'];
class TMSRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
        this._log();
    }
    onAdd(p, args) {
        this._log('onAdd', [p, args]);
        if (args && args.onInit) {
            args.onInit(p);
        }
        var sub = new rxjs_1.Subject();
        let me = this;
        var prom = null;
        if (p.proxyMeta && p.proxyMeta.ion)
            prom = Cesium.IonResource.fromAssetId(p.proxyMeta.layer_id, { accessToken: p.proxyMeta.accessToken });
        else
            prom = this.cesium.getAuthenticatedUrl(p, '', 1);
        prom.then(url => {
            if (args && args.onStart) {
                args.onStart(p, v);
            }
            var v = new Cesium.TileMapServiceImageryProvider({
                url: url
            });
            if (args && args.onProcess) {
                args.onProcess(p, layer);
            }
            var layer = this.cesium.viewer.scene.imageryLayers.addImageryProvider(v);
            layer.transform_type = 'transform';
            layer.transform_id = p.id;
            if (args && args.onDuring) {
                args.onDuring(p, layer);
            }
            v.readyPromise.then(() => {
                var plt = {
                    object: layer,
                    plottable: p
                };
                if (!p.llng || p.llng == -180) {
                    p.llng = Cesium.Math.toDegrees(v.rectangle.west);
                    p.ulng = Cesium.Math.toDegrees(v.rectangle.east);
                    p.llat = Cesium.Math.toDegrees(v.rectangle.south);
                    p.ulat = Cesium.Math.toDegrees(v.rectangle.north);
                    p.saveObservable().subscribe(_ => {
                        if (args && args.onEnd) {
                            args.onEnd(p);
                        }
                        sub.next(plt);
                        sub.complete();
                    });
                }
                else {
                    if (args && args.onEnd) {
                        args.onEnd(p);
                    }
                    sub.next(plt);
                    sub.complete();
                }
            });
        });
        return sub.asObservable();
    }
    onRemove(obj, pr) {
        this.cesium.viewer.scene.imageryLayers.remove(pr.object);
        return rxjs_1.of(null);
    }
}
exports.TMSRenderer = TMSRenderer;
class LASRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
        this._log();
    }
    onAdd(p, args) {
        this._log('onAdd', [p, args]);
        if (args && args.onInit) {
            args.onInit(p);
        }
        var baseArgs = {};
        if (this.cesium.fourdD.domainConfig && this.cesium.fourdD.domainConfig.cesium && this.cesium.fourdD.domainConfig.cesium.las)
            baseArgs = this.cesium.fourdD.domainConfig.cesium.las;
        baseArgs.url = p['input'].file('data');
        if (!baseArgs.maximumScreenSpaceError)
            baseArgs.maximumScreenSpaceError = args && args.maximumScreenSpaceError ? args.maximumScreenSpaceError : (p['maximumScreenSpaceError'] || 2);
        if (!baseArgs.maximumNumberOfLoadedTiles)
            baseArgs.maximumNumberOfLoadedTiles = 1000;
        var c = new Cesium.Cesium3DTileset(baseArgs);
        if (c.tileFailed) {
            this.monitorEvent('tileFailed', c.tileFailed);
        }
        if (args && args.onStart) {
            args.onStart(p, c);
        }
        this.cesium.viewer.scene.primitives.add(c);
        if (args && args.onProcess) {
            args.onProcess(p, c);
        }
        var sub = new rxjs_1.Subject();
        c.readyPromise.then(() => {
            var plt = {
                plottable: p,
                object: c,
                boundingSphere: c.boundingSphere
            };
            if (args && args.onEnd) {
                args.onEnd(p, plt);
            }
            sub.next(plt);
            sub.complete();
        });
        return sub.asObservable();
    }
    onRemove(obj, pr) {
        this.cesium.viewer.scene.primitives.remove(pr.object);
        return rxjs_1.of(null);
    }
}
exports.LASRenderer = LASRenderer;
class ThreeDTileRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
        this._log();
    }
    onAdd(p, args) {
        this._log('onAdd', [p, args]);
        if (args && args.onInit) {
            args.onInit(p);
        }
        var sub = new rxjs_1.Subject();
        let me = this;
        var prom = null;
        // when its an ion resrouce
        if (p.proxyMeta && p.proxyMeta.ion)
            prom = Cesium.IonResource.fromAssetId(p.proxyMeta.layer_id, { accessToken: p.proxyMeta.accessToken });
        else if (p.isProxy)
            prom = Promise.resolve(p.file(p['proxyMeta'] ? p['proxyMeta'].name : 'tileset.json'));
        else
            prom = this.cesium.getAuthenticatedUrl(p, '3Dtiles_root.json', 2);
        prom.then(url => {
            var baseArgs = {};
            if (this.cesium.fourdD.domainConfig && this.cesium.fourdD.domainConfig.cesium && this.cesium.fourdD.domainConfig.cesium.threeD)
                baseArgs = this.cesium.fourdD.domainConfig.cesium.threeD;
            baseArgs.url = url;
            if (!baseArgs.maximumScreenSpaceError)
                baseArgs.maximumScreenSpaceError = args && args.maximumScreenSpaceError ? args.maximumScreenSpaceError : (p['maximumScreenSpaceError'] || 2);
            if (!baseArgs.maximumNumberOfLoadedTiles)
                baseArgs.maximumNumberOfLoadedTiles = 1000;
            var c = new Cesium.Cesium3DTileset(baseArgs);
            if (c.tileFailed) {
                me.monitorEvent('tileFailed', c.tileFailed);
            }
            c.id = p.vertical_offset;
            if (args && args.onStart) {
                args.onStart(p, c);
            }
            me.cesium.viewer.scene.primitives.add(c);
            c.transform_type = 'transform';
            c.transform_id = p.id;
            if (args && args.onProcess) {
                args.onProcess(p, c);
            }
            c.readyPromise.then(() => {
                if (args && args.onDuring) {
                    args.onDuring(p, c);
                }
                var cartographic = null;
                if (c.pointCloudShading && p['pointCloudShading']) {
                    Object.keys(p['pointCloudShading']).forEach(k => c.pointCloudShading[k] = p['pointCloudShading'][k] || c.pointCloudShading[k]);
                }
                if (p['shading']) {
                    c.normalShading = false;
                    c.style = new Cesium.Cesium3DTileStyle({
                        color: 'color("lightgray")'
                    });
                }
                if (p.matrix && p.matrix.length == 16) {
                    c.modelMatrix = Cesium.Matrix4.fromArray(p.matrix);
                    cartographic = Cesium.Cartographic.fromCartesian(c.boundingSphere.center);
                    var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0);
                    var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, p.vertical_offset || 0);
                    var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
                    c.modelMatrix = Cesium.Matrix4.multiplyByTranslation(c.modelMatrix, translation, {});
                }
                else {
                    cartographic = Cesium.Cartographic.fromCartesian(c.boundingSphere.center);
                    var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0);
                    var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, p.vertical_offset || 0);
                    var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
                    c.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
                }
                // update the meta data of the dataset
                var plt = {
                    plottable: p,
                    object: c,
                    boundingSphere: c.boundingSphere
                };
                if (!p.llng || p.llng == -180) {
                    p.llng = Cesium.Math.toDegrees(cartographic.longitude) - 0.001;
                    p.llat = Cesium.Math.toDegrees(cartographic.latitude) - 0.001;
                    p.ulng = Cesium.Math.toDegrees(cartographic.longitude) + 0.001;
                    p.ulat = Cesium.Math.toDegrees(cartographic.latitude) + 0.001;
                    p.saveObservable().subscribe(_ => {
                        if (args && args.onEnd) {
                            args.onEnd(p, c);
                        }
                        sub.next(plt);
                        sub.complete();
                    });
                }
                else {
                    if (args && args.onEnd) {
                        args.onEnd(p, c);
                    }
                    sub.next(plt);
                    sub.complete();
                }
            });
        });
        return sub.asObservable();
    }
    onRemove(obj, pr) {
        this.cesium.viewer.scene.primitives.remove(pr.object);
        return rxjs_1.of(null);
    }
}
exports.ThreeDTileRenderer = ThreeDTileRenderer;
class KMLRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        this.entityTypes = ['_name', '_description', '_polygon', '_polyline', '_billboard', '_point', '_label', '_corridor', '_cylinder', '_ellipse', '_path', '_plane', '_position', '_rectangle', '_wall', '_tileset'];
        if (!Cesium)
            Cesium = window['Cesium'];
        this._log();
    }
    onAdd(p, args) {
        this._log('onAdd', [p, args]);
        let me = this;
        var tt = p.transformType.uid;
        let id = '_' + p.id + '_' + tt;
        var url = p.file('data');
        var datasource = null;
        var options = null;
        // NOTE: default clamping for KML is true, while geo-json is false (KML is more often flat surfaces, while GeoJSON are used for 3D objects more)
        if (tt == 'kml') {
            // KML/KMZ
            options = {
                camera: me.cesium.viewer.scene.camera,
                canvas: me.cesium.viewer.scene.canvas,
                transform_id: p.id,
                transform_type: 'transform',
                clampToGround: args ? (args.hasOwnProperty('clamping') ? args['clamping'] : true) : true,
            };
            datasource = new Cesium.KmlDataSource(options);
        }
        else {
            // GeoJSON
            options = {
                stroke: p['customColor'] ? Cesium.Color.fromCssColorString(p['customColor']) : Cesium.Color.RED.withAlpha(0.5),
                fill: p['customColor'] ? Cesium.Color.fromCssColorString(p['customColor']) : Cesium.Color.RED.withAlpha(0.5),
                strokeWidth: 3,
                markerSymbol: '?',
                transform_id: p.id,
                transform_type: 'transform',
                clampToGround: args ? (args.hasOwnProperty('clamping') ? args['clamping'] : false) : false,
            };
            datasource = new Cesium.GeoJsonDataSource(options);
        }
        datasource.entities['__id'] = id;
        datasource.entities['__callback'] = false;
        // Might be re-instated later, so leave in for now
        /*
        var fu = function onChanged(collection, added, removed, changed){
            if ( added.length ) {
                var msg = '---- viewer.entities ----- Added ['+added.length+'] ids: ';
                for(var i = 0; i < added.length; i++) {
                    msg += ' ' + added[i].id + ( added[i]._children ? '('+added[i]._children.length+')' : '' );
                }
                console.log(msg,added);
            }
        }
        var fo = function onChanged(collection, added, removed, changed){
            if ( added.length ) {
                var msg = '---- datasource.entities ----- Added ['+added.length+'] ids: ';
                for(var i = 0; i < added.length; i++) {
                    msg += ' ' + added[i].id + ( added[i]._children ? '('+added[i]._children.length+')' : '' );
                }
                console.log(msg,added);
            }
        }
        me.cesium.viewer.entities.collectionChanged.addEventListener(fu);
        datasource.entities.collectionChanged.addEventListener(fo);
        */
        /* testing     datasource.entities.collectionChanged.addEventListener( function(collection, added, removed, changed) {
            if(args && args.onDuring) { args.onDuring(p,added); }
            if ( collection['__callback'] ) { return; }
            if ( added.length ) {
                collection['__callback'] = true;
                //collection.suspendEvents();
                //if ( added && added.length ) {
                    console.log(' ---- ['+collection['__id']+'] [entities] event', collection, collection['__callback'], added, removed, changed );
                //}
                //collection.resumeEvents();
                collection['__callback'] = false;
            }
        } ); */
        if (args && args.onInit) {
            args.onInit(p, datasource);
        }
        /* testing
        var resource = new Cesium.Resource({ url:url });
        console.log('################## json', resource );

        resource.fetchXML().then( data => {
            console.log('################## json RESULT', data );
        }).otherwise( error => {
            // an error occurred
            console.log('################## json ERROR', error );
        });
        */
        var promise = datasource.load(url, options);
        if (args && args.onStart) {
            args.onStart(p, promise);
        }
        var obj = me.cesium.viewer.dataSources.add(promise);
        // console.log("### STATS ["+tt+"] ADD" );
        if (args && args.onProcess) {
            args.onProcess(p, obj);
        }
        var sub = new rxjs_1.Subject();
        obj.then((dataSource) => {
            // console.log("### STATS ["+tt+"] INIT" );
            var pixelRange = 15;
            var minimumClusterSize = 3;
            var enabled = true;
            /*
            dataSource.clustering.enabled = enabled;
            dataSource.clustering.pixelRange = pixelRange;
            dataSource.clustering.minimumClusterSize = minimumClusterSize;

            var pinBuilder = new Cesium.PinBuilder();

            var range = [50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2 ];
            var colors = [Cesium.Color.RED, Cesium.Color.ORANGE, Cesium.Color.YELLOW, Cesium.Color.GREEN, Cesium.Color.BLUE, null, null, null, null, null, null, null, null, null ]
            var pins = {};
            var count = 0;
            range.forEach( n => {
                pins[n] = pinBuilder.fromText( n + (n > 9 ? '+':''), colors[count] ? colors[count] : Cesium.Color.VIOLET, 45).toDataURL();
                count++;
            });

            // console.log('## pins', pins );

            dataSource.clustering.clusterEvent.addEventListener(
                function (clusteredEntities, cluster) {

                    cluster.label.show = false;
                    cluster.billboard.show = true;
                    cluster.billboard.id = cluster.label.id;
                    cluster.billboard.verticalOrigin = Cesium.VerticalOrigin.BOTTOM;

                    for ( let n=0; n<range.length; n++ ) {
                        if (clusteredEntities.length >= range[n] ) {
                            cluster.billboard.image = pins[range[n]];
                            // console.log('## cluster',n,clusteredEntities.length,range[n],pins[range[n]] );
                            break;
                        }
                    }
                }
            );
                */
            var entities = dataSource.entities.values;
            dataSource.entities.transform_id = p.id;
            dataSource.entities.transform_type = 'transform';
            // quick and dirty semi-recursive loop to find all entities within entities within entities ...
            /* var c_total=0,c_c=0,c_cc=0,c_ccc=0,c_cccc=0,c_entities=0;
            entities.forEach ( e => {
                c_entities++;
                c_total++;
                if ( e._children ) {
                    e._children.forEach ( c => {
                        c_c++;
                        c_total++;
                        if ( c._children ) {
                            c._children.forEach ( cc => {
                                c_cc++;
                                c_total++;
                                if ( cc._children ) {
                                    cc._children.forEach ( ccc => {
                                        c_ccc++;
                                        c_total++;
                                        if ( ccc._children ) {
                                            ccc._children.forEach ( cccc => {
                                                c_cccc++;
                                                c_total++;
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    });
                }
            });
            */
            /*


            let timer_start = performance.now();
            console.log("### STATS ["+tt+"] BEGIN" );

            // var colorHash = {};
            var pints = []
            for (var i = 0; i < entities.length; i++) {
                //For each entity, create a random color based on the state name.
                //Some states have multiple entities, so we store the color in a
                //hash so that we use the same color for the entire state.
                var entity = entities[i];
                if(entity.position)
                    pints.push(entity.position.getValue())
                else if(entity.polygon)
                    entity.polygon.hierarchy.getValue().positions.forEach(p => pints.push(p))
                else if(entity.polyline)
                    entity.polyline.positions.getValue().forEach(p => pints.push(p))
            }
            */
            var res = {
                plottable: p,
                object: dataSource,
            };
            // let timer_middle = performance.now();
            let stats = this.pullEntities(entities);
            if (stats && stats['_stats'] && stats['_stats']['total_positions']) {
                let pos = stats['_stats']['total_positions'];
                if (pos.length > 1) {
                    res.boundingSphere = Cesium.BoundingSphere.fromPoints(pos);
                }
                else if (pos.length) {
                    res.position = pos[0];
                }
            }
            /*
                        
                        let timer_end = performance.now();
            
                        console.log("### STATS ["+tt+"] ONE", pints.length, timer_middle - timer_start );
                        console.log("### STATS ["+tt+"] TWO", stats['_stats']['total_positions'].length, timer_end - timer_middle );
            */
            if (args && args.onEnd) {
                args.onEnd(p, res);
            }
            // console.log("### STATS ["+tt+"] END", pints, stats['_stats'] );
            sub.next(res);
            sub.complete();
        });
        return sub.asObservable();
    }
    onRemove(obj, pr) {
        this.cesium.viewer.dataSources.remove(pr.object);
        //var i =this.viewer.dataSources._dataSources.findIndex( e => e._entityCollection.id === obj.object['_entityCollection'].id);
        //this.viewer.dataSources.remove(this.viewer.dataSources._dataSources[i]);
        return rxjs_1.of(null);
    }
    pullEntities(entities, data = {}, stats = null, level = 1) {
        if (!stats) {
            stats = {
                total_entities: 0,
                total_collections: 0,
                total_levels: 0,
                total_positions: []
            };
        }
        stats['total_collections']++;
        if (entities && entities.length) {
            let n = 0;
            // console.log('## pull', entities.length);
            entities.forEach((pp, i) => {
                n++;
                stats['total_entities']++;
                if (level > stats['total_levels']) {
                    stats['total_levels'] = level;
                }
                let item = {
                    id: level + '_' + n,
                    entity: pp,
                    have_children: pp._children ? pp._children.length : 0
                };
                if (data['parent']) {
                    item['parent'] = data['parent'];
                }
                this.entityTypes.forEach(et => {
                    if (pp[et]) {
                        item[et] = pp[et];
                        if (!stats[et]) {
                            stats[et] = 0;
                        }
                        stats[et]++;
                    }
                });
                if (pp.position)
                    stats.total_positions.push(pp.position.getValue());
                else if (pp.polygon)
                    pp.polygon.hierarchy.getValue().positions.forEach(p => stats.total_positions.push(p));
                else if (pp.polyline)
                    pp.polyline.positions.getValue().forEach(p => stats.total_positions.push(p));
                if (item.have_children) {
                    item['_children'] = this.pullEntities(pp._children, { parent: item.id }, stats, level + 1);
                }
                // uncomment the below to get an entry for each item
                // data['__'+item.id+'_'+item.have_children] = item;
            });
        }
        if (level == 1) {
            data['_stats'] = stats;
        }
        return data;
    }
}
exports.KMLRenderer = KMLRenderer;
class PhotoRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
        this._log();
    }
    onAdd(p, args) {
        this._log('onAdd', [p, args]);
        var height = args && args.vertical_invert ? args.vertical_invert - p.uheight : p.uheight;
        var carto = Cesium.Cartographic.fromDegrees(p.llng, p.llat, height);
        var pos = Cesium.Cartographic.toCartesian(carto);
        var plotable = {
            position: pos,
            name: p.name,
            transform_id: p.id,
            transform_type: 'transform'
        };
        var color = (p['accent'] && Cesium.Color[p['accent']]) ? Cesium.Color[p['accent']].withAlpha(p['alpha'] || 0.5) : Cesium.Color.RED.withAlpha(0.5);
        // Sphere
        var defaultEntity = {
            point: {
                pixelSize: 10,
                color: color
            }
        };
        if (p.heading != undefined && p.pitch != undefined && p.roll != undefined && args && args.showOrientation) {
            plotable.orientation = Cesium.Transforms.headingPitchRollQuaternion(pos, new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(p.heading - 90), Cesium.Math.toRadians(p.pitch), Cesium.Math.toRadians(p.roll)));
            // camera icon
            defaultEntity = { model: {
                    uri: '/assets/images/camera.glb',
                    minimumPixelSize: 18,
                    maximumScale: 100,
                    scale: 0.005,
                    color: color
                }
            };
        }
        Object.assign(plotable, (args && args.entity) ? args.entity : defaultEntity);
        var obj = this.cesium.dziDatasource.entities.add(plotable);
        return rxjs_1.of({
            plottable: p,
            object: obj
        });
    }
    onRemove(obj, pr) {
        this.cesium.dziDatasource.entities.remove(pr.object);
        return rxjs_1.of(null);
    }
}
exports.PhotoRenderer = PhotoRenderer;
class TerrainRenderer extends renderer_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
        this._log();
    }
    onAdd(p, args) {
        this._log('onAdd', [p, args]);
        var urlPromse = null;
        if (p.proxyMeta && p.proxyMeta.ion)
            urlPromse = Cesium.IonResource.fromAssetId(p.proxyMeta.layer_id, { accessToken: p.proxyMeta.accessToken });
        else
            urlPromse = this.cesium.getAuthenticatedUrl(p, '', 0);
        if (args && args.onInit) {
            args.onInit(p);
        }
        var res = rxjs_1.from(urlPromse.then(url => {
            if (args && args.onStart) {
                args.onStart(p);
            }
            var t = new Cesium.CesiumTerrainProvider({
                url: url,
                requestVertexNormals: true
            });
            if (args && args.onProcess) {
                args.onProcess(p, t);
            }
            this.cesium.viewer.scene.terrainProvider = t;
            this.cesium.viewer.scene.terrainProvider.transform_type = 'transform';
            this.cesium.viewer.scene.terrainProvider.transform_id = p.id;
            if (args && args.onEnd) {
                args.onEnd(p, this.cesium.viewer.scene.terrainProvider);
            }
            return {
                plottable: p,
                object: this.cesium.viewer.scene.terrainProvider
            };
        }));
        return res;
    }
    onRemove(obj, pr) {
        this.cesium.viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
        return rxjs_1.of(null);
    }
}
exports.TerrainRenderer = TerrainRenderer;
/*

class TerrainTileRenderer extends Renderer<Transform>{
    constructor(private cesium:FourdCesiumHelper){
        super()
    }
    onAdd(p: Transform,args?:any): Observable<PlottableReference> {
        var res = from(this.cesium.getAuthenticatedUrl(p,'',0).then(url => {
            const tilingScheme = new Cesium.WebMercatorTilingScheme()

            this.cesium.viewer.terrainProvider =  new Cesium.CesiumTerrainProvider({
                url : url,
                requestVertexNormals: true
            });
            
            return {
                     plottable:p,
                     object:this.cesium.viewer.terrainProvider
                 }
             }))
        return res
    }
    onRemove(obj: Transform, pr: PlottableReference): Observable<PlottableReference> {
        this.cesium.viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider()
        return of(null)
    }


}*/ 
